import { render, staticRenderFns } from "./view.html?vue&type=template&id=3900e4ba&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=3900e4ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900e4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3900e4ba')) {
      api.createRecord('3900e4ba', component.options)
    } else {
      api.reload('3900e4ba', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=3900e4ba&scoped=true&", function () {
      api.rerender('3900e4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stockAward/index.vue"
export default component.exports